import {command, queryAll, queryOne, querySearch} from "../utils/api";

const GET_BULK_PRODUCTS_URL = `${process.env.PUBLIC_URL}/api/v1/r/bulkProducts`;
export const GET_BULK_PRODUCTS = 'GET_BULK_PRODUCTS';
export const GET_BULK_PRODUCTS_COMPLETED = 'GET_BULK_PRODUCTS_COMPLETED';
export const GET_BULK_PRODUCTS_FAILED = 'GET_BULK_PRODUCTS_FAILED';
export function getBulkProducts({dispensaryId}) {
  const queryFilter = {
    where: {dispensaryId: {eq: dispensaryId}},
    order: "name ASC"
  };
  return queryAll(GET_BULK_PRODUCTS_URL, queryFilter, GET_BULK_PRODUCTS, GET_BULK_PRODUCTS_COMPLETED, GET_BULK_PRODUCTS_FAILED);
}

export const SEARCH_BULK_PRODUCTS = 'SEARCH_BULK_PRODUCTS';
export const SEARCH_BULK_PRODUCTS_COMPLETED = 'SEARCH_BULK_PRODUCTS_COMPLETED';
export const SEARCH_BULK_PRODUCTS_FAILED = 'SEARCH_BULK_PRODUCTS_FAILED';
export const searchBulkProducts = querySearch(GET_BULK_PRODUCTS_URL, SEARCH_BULK_PRODUCTS, SEARCH_BULK_PRODUCTS_COMPLETED, SEARCH_BULK_PRODUCTS_FAILED,
  ['name', 'description', 'supplierName', 'unitOfMeasureClass']);

export const GET_BULK_PRODUCT = 'GET_BULK_PRODUCT';
export const GET_BULK_PRODUCT_COMPLETED = 'GET_BULK_PRODUCT_COMPLETED';
export const GET_BULK_PRODUCT_FAILED = 'GET_BULK_PRODUCT_FAILED';
export function getBulkProduct({bulkProductId}) {
  return queryOne(GET_BULK_PRODUCTS_URL, {where: {bulkProductId}}, GET_BULK_PRODUCT, GET_BULK_PRODUCT_COMPLETED, GET_BULK_PRODUCT_FAILED);
}

const BULK_PRODUCT_ACTION_URL = `${process.env.PUBLIC_URL}/api/v1/bulkProduct`;
export const ADD_BULK_PRODUCT = 'ADD_BULK_PRODUCT';
export const ADD_BULK_PRODUCT_COMPLETED = 'ADD_BULK_PRODUCT_COMPLETED';
export const ADD_BULK_PRODUCT_FAILED = 'ADD_BULK_PRODUCT_FAILED';
export const addBulkProduct = command(BULK_PRODUCT_ACTION_URL + '/addBulkProduct', ADD_BULK_PRODUCT, ADD_BULK_PRODUCT_COMPLETED, ADD_BULK_PRODUCT_FAILED);

export const UPDATE_BULK_PRODUCT = 'UPDATE_BULK_PRODUCT';
export const UPDATE_BULK_PRODUCT_COMPLETED = 'UPDATE_BULK_PRODUCT_COMPLETED';
export const UPDATE_BULK_PRODUCT_FAILED = 'UPDATE_BULK_PRODUCT_FAILED';
export const updateBulkProduct = command(BULK_PRODUCT_ACTION_URL + '/updateBulkProduct', UPDATE_BULK_PRODUCT, UPDATE_BULK_PRODUCT_COMPLETED, UPDATE_BULK_PRODUCT_FAILED);

export const DELETE_BULK_PRODUCT = 'DELETE_BULK_PRODUCT';
export const DELETE_BULK_PRODUCT_COMPLETED = 'DELETE_BULK_PRODUCT_COMPLETED';
export const DELETE_BULK_PRODUCT_FAILED = 'DELETE_BULK_PRODUCT_FAILED';
export const deleteBulkProduct = command(
  BULK_PRODUCT_ACTION_URL + '/deleteBulkProduct',
  DELETE_BULK_PRODUCT,
  DELETE_BULK_PRODUCT_COMPLETED,
  DELETE_BULK_PRODUCT_FAILED
);

export const SHOW_DELETE_BULK_PRODUCT_MODAL = 'SHOW_DELETE_BULK_PRODUCT_MODAL';
export function showDeleteBulkProductModal(bulkProduct) {
  return {type: SHOW_DELETE_BULK_PRODUCT_MODAL, payload: bulkProduct};
}

export const HIDE_DELETE_BULK_PRODUCT_MODAL = 'HIDE_DELETE_BULK_PRODUCT_MODAL';
export function hideDeleteBulkProductModal() {
  return {type: HIDE_DELETE_BULK_PRODUCT_MODAL};
}



// WEBPACK FOOTER //
// ./src/BulkProduct/actions.js